import React,{useState, useEffect} from 'react';
import { Modal } from 'react-bootstrap';
import closeIcon from '../../images/popups/upload/closeicon.png';
import getResponseEntity from '../actions/Entity.js';
import { useNavigate } from "react-router-dom";
import '../../scss/popups/edit_project_confirm.scss';

function EditProjectConfirm({showeditconfirm, handleConfirmHide, DifferentEntity, SameEntity, projectname, 
    enable}) {
    return (
        <>
            <Modal
                show={showeditconfirm}
                onHide={handleConfirmHide} className='confirm-item-popup'
                centered>
                <Modal.Body className='confirm-item-body'>
                    <div className='close-icon'>
                        <img src={closeIcon} onClick={handleConfirmHide}/>
                    </div>
                    <div className='confirm-popup-header'>Confirm Edit</div>
                    <div className='confirm-popup-subheader'>Are you sure to replace the tasks of {projectname} project?</div>
                    <div className='confirm-button'>
                        <button disabled={enable ? false : true} className={`button ${enable ? 'button-enable' : 'button-disable'}`} onClick={DifferentEntity}>Yes</button>
                        <button disabled={enable ? false : true} className={`button no-button ${enable ? 'button-enable' : 'button-disable'}`} onClick={SameEntity}>No</button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default EditProjectConfirm;